import { getCdnAssetUrl } from '@/assets';

export const brandingDashSocial = Object.defineProperties(
  {
    appName: 'Dash Social',
    abbreviated: 'Dash',
  },
  {
    logoPrimary: {
      get: () => getCdnAssetUrl('dashsocial/dash-social-logo-primary-black.svg'),
      enumerable: true,
    },
    iconPrimary: {
      get: () => getCdnAssetUrl('dashsocial/dash-social-icon-primary.svg'),
      enumerable: true,
    },
    iconPlaceholder: {
      get: () => getCdnAssetUrl('dashsocial/dash-social-icon-primary.svg'),
      enumerable: true,
    },

    // These are alternate variants of the branding that are currently unused
    logoPrimaryWhite: {
      get: () => getCdnAssetUrl('dashsocial/dash-social-logo-primary-white.svg'),
      enumerable: true,
    },
    logoBlack: {
      get: () => getCdnAssetUrl('dashsocial/dash-social-logo-black.svg'),
      enumerable: true,
    },
    logoWhite: {
      get: () => getCdnAssetUrl('dashsocial/dash-social-logo-white.svg'),
      enumerable: true,
    },

    iconBlack: {
      get: () => getCdnAssetUrl('dashsocial/dash-social-icon-black.svg'),
      enumerable: true,
    },
    iconWhite: {
      get: () => getCdnAssetUrl('dashsocial/dash-social-icon-white.svg'),
      enumerable: true,
    },
  },
);
